var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPpt(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16539_208429)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.532 0H10.9507L15.7339 4.78409V13.971C15.7339 15.0865 14.8213 16 13.7048 16H5.53203C4.41647 16 3.50391 15.0865 3.50391 13.971V2.02903C3.50391 0.913469 4.41647 0 5.532 0Z",
    fill: "#D8DFE3",
    style: (_ref2 = {
      fill: "#D8DFE3"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.8471 0.8745 0.8902)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9551 0L15.7383 4.78409H11.4708C11.1864 4.78409 10.9551 4.55184 10.9551 4.26747V0Z",
    fill: "#AFBDC7",
    style: (_ref3 = {
      fill: "#AFBDC7"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.6863 0.7412 0.7804)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.0198 4.78271H3.3125V12.3873H7.0198C7.16753 12.3866 7.30901 12.3277 7.4136 12.2233C7.51819 12.119 7.57746 11.9777 7.57857 11.83V5.34007C7.57746 5.19235 7.51819 5.05102 7.4136 4.94669C7.30901 4.84236 7.16753 4.78345 7.0198 4.78271Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.71515 5.08887H3.3125V12.6935H6.71515C6.86288 12.6927 7.00436 12.6338 7.10895 12.5295C7.21354 12.4252 7.27281 12.2838 7.27391 12.1361V5.64623C7.27281 5.4985 7.21354 5.35717 7.10895 5.25284C7.00436 5.14851 6.86288 5.0896 6.71515 5.08887Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.71515 5.08887H3.3125V12.0851H6.71515C6.86288 12.0844 7.00436 12.0255 7.10895 11.9211C7.21354 11.8168 7.27281 11.6755 7.27391 11.5277V5.64623C7.27281 5.4985 7.21354 5.35717 7.10895 5.25284C7.00436 5.14851 6.86288 5.0896 6.71515 5.08887Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.4105 5.08887H3.3125V12.0851H6.4105C6.55822 12.0844 6.69971 12.0255 6.8043 11.9211C6.90889 11.8168 6.96816 11.6755 6.96926 11.5277V5.64623C6.96816 5.4985 6.90889 5.35717 6.8043 5.25284C6.69971 5.14851 6.55822 5.0896 6.4105 5.08887Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.820482 5.08887H6.40718C6.55516 5.08875 6.69715 5.14738 6.80192 5.25189C6.9067 5.35641 6.96569 5.49824 6.96594 5.64623V11.2236C6.96569 11.3716 6.9067 11.5134 6.80192 11.6179C6.69715 11.7224 6.55516 11.781 6.40718 11.7809H0.820482C0.747153 11.7812 0.674498 11.7669 0.606686 11.739C0.538874 11.7111 0.477241 11.6701 0.425324 11.6183C0.373407 11.5665 0.332229 11.505 0.304153 11.4373C0.276078 11.3695 0.261657 11.2969 0.261719 11.2236V5.64623C0.261657 5.5729 0.276078 5.50028 0.304153 5.43254C0.332229 5.3648 0.373407 5.30327 0.425324 5.25148C0.477241 5.1997 0.538874 5.15867 0.606686 5.13077C0.674498 5.10286 0.747153 5.08862 0.820482 5.08887Z",
    fill: "#FF3E4C",
    style: (_ref4 = {
      fill: "#FF3E4C"
    }, _defineProperty(_ref4, "fill", "color(display-p3 1.0000 0.2431 0.2980)"), _defineProperty(_ref4, "fillOpacity", 1), _ref4)
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53787 10.7827C2.3963 10.7827 2.28125 10.6676 2.28125 10.526V8.79812C2.28125 8.65655 2.3963 8.5415 2.53787 8.5415C2.67944 8.5415 2.79449 8.65655 2.79449 8.79812V10.526C2.79449 10.6676 2.67944 10.7827 2.53787 10.7827Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61397 9.05551H2.53787C2.3963 9.05551 2.28125 8.94046 2.28125 8.79889V6.64627C2.28125 6.5047 2.3963 6.38965 2.53787 6.38965H3.61397C4.34919 6.38965 4.94711 6.98758 4.94711 7.72237C4.94711 8.45759 4.34919 9.05551 3.61397 9.05551ZM2.79449 8.54227H3.61397C4.06605 8.54227 4.43387 8.17445 4.43387 7.72279C4.43387 7.27071 4.06605 6.90289 3.61397 6.90289H2.79449V8.54227Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2988 10.117C11.1464 10.1168 11.023 9.99317 11.023 9.84084V7.34819C11.023 7.18997 10.8899 7.06287 10.7335 7.08692C10.0975 7.18473 9.50871 7.49094 9.06204 7.9617C8.5483 8.50318 8.26186 9.22111 8.26172 9.96749C8.2616 10.3502 8.33688 10.7292 8.48328 11.0828C8.62969 11.4364 8.84434 11.7577 9.11496 12.0283C9.38558 12.2989 9.70688 12.5136 10.0605 12.66C10.414 12.8064 10.7931 12.8817 11.1758 12.8816C11.9222 12.8817 12.6401 12.5952 13.1815 12.0814C13.6523 11.6346 13.9583 11.0455 14.0557 10.4092C14.0796 10.253 13.9527 10.1201 13.7947 10.1199L11.2988 10.117Z",
    fill: "#FF3E4C",
    style: (_ref5 = {
      fill: "#FF3E4C"
    }, _defineProperty(_ref5, "fill", "color(display-p3 1.0000 0.2431 0.2980)"), _defineProperty(_ref5, "fillOpacity", 1), _ref5)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8789 6.85687C11.7227 6.83312 11.5898 6.96016 11.5898 7.11821V9.31274C11.5898 9.46525 11.7135 9.58887 11.866 9.58887H14.0605C14.2186 9.58887 14.3456 9.45605 14.3219 9.29985C14.2288 8.68786 13.9427 8.11856 13.5014 7.6773C13.0601 7.23602 12.4909 6.94991 11.8789 6.85687Z",
    fill: "#FF3E4C",
    style: (_ref6 = {
      fill: "#FF3E4C"
    }, _defineProperty(_ref6, "fill", "color(display-p3 1.0000 0.2431 0.2980)"), _defineProperty(_ref6, "fillOpacity", 1), _ref6)
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16539_208429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.67b69d8b.svg";
export { ForwardRef as ReactComponent };